// import "bootstrap";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/dropdown";

let init = false;


document.addEventListener("DOMContentLoaded", () => {
    // sticky animated nav

    const nav = document.getElementById("stickyHeader");
    let scrollDirection = 0;
    function fixNav() {
        if (window.scrollY >= 5) {
            if (scrollDirection > window.scrollY) {
                nav.classList.add("headerScrolled");
                nav.style.animationName = "headerSlideIn";
            } else {
                nav.style.animationName = "headerSlideOut";
            }
            scrollDirection = window.scrollY;

            if (!document.querySelector(".page-quote")) {
                const contactBtn = document.querySelector("#contact-btn");
                const ebookMobileBtn = document.querySelector("#ebook-mobile-btn");
                if (window.scrollY > 400) {
                    if(contactBtn) {
                        contactBtn.classList.add("show");
                    }
                    if(ebookMobileBtn){
                        ebookMobileBtn.classList.add("show");
                    }
                } else {
                    if(contactBtn) {
                        contactBtn.classList.remove("show");
                    }
                    if(ebookMobileBtn){
                        ebookMobileBtn.classList.remove("show");
                    }
                }

                const ebookBtn = document.getElementById("ebook-mobile-btn");
                if(ebookBtn && contactBtn) {
                    contactBtn.classList.remove("show");
                }
            }
        } else {
            nav.style.backgroundColor = "transparent";
            nav.style.animationName = "headerSticked";
            document.body.classList.remove("headerScrolled");
        }
    }
    window.addEventListener("scroll", fixNav);

    // make correct active team member in the modal
    // const sectionTeam = document.getElementById("sectionTeam");
    // if (sectionTeam)
    //   sectionTeam.addEventListener("click", (el) => {
    //     const buttonWithData = el.target.closest("button");
    //     const memberEl = document.querySelector(
    //       `#teamModal .carousel-item[data-member-id='${buttonWithData.dataset.memberId}']`
    //     );
    //     if (memberEl) {
    //       document
    //         .querySelectorAll("#teamModal .carousel-item")
    //         .forEach((it) => it.classList.remove("active"));
    //       memberEl.classList.add("active");
    //     }
    //   });

    // move backdrop before the modal
    const btnFullscreenModal = document.querySelector(".btn-fulscreen-modal");
    if (btnFullscreenModal)
    btnFullscreenModal.addEventListener("click", () => {
        const backdrop = document.querySelector(".modal-backdrop");
        const formQuoteWrap = document.querySelector(".form-quote-wrap");
        if (backdrop) formQuoteWrap.appendChild(backdrop);
    });
});

if (document.querySelectorAll(".youtube-player[data-id]").length) {
    document.querySelectorAll(".youtube-player[data-id]").forEach((el) => {
        el.addEventListener("click", (e) => {
            const dataId = e.currentTarget.dataset.id;
            const src = `https://www.youtube.com/embed/${dataId}?autoplay=1`;

            el.querySelector("iframe").setAttribute("src", src);
            el.querySelector(".process__video_preview").remove();
        });
    });
}

window.onload = () => {
    // document.querySelector("head").append(fontawesome);
    // document.querySelector("head").append(appCss);


    if (window.scrollY > 0) {
        if (!init) {
            init = true;
            document.querySelectorAll("[data-src]").forEach((el) => {
                const s = el.dataset.src;
                const set = el.dataset.srcset;
                el.setAttribute("src", s);
                if (set) el.setAttribute("srcset", s);
            });
        }
    } else {

        const viewportHeight = window.innerHeight;
        document.querySelectorAll("[data-src]").forEach((el) => {
            if(viewportHeight >= el.offsetTop) {
                const imageSrc = el.dataset.src;
                const imageSrcSet = el.dataset.srcset;
                el.setAttribute("src", imageSrc);
                if (imageSrcSet) el.setAttribute("srcset", imageSrc);
            }
        });


        document.addEventListener("scroll", (e) => {
            if (!init) {
                init = true;
                document.querySelectorAll("[data-src]").forEach((el) => {
                    const s = el.dataset.src;
                    const set = el.dataset.srcset;
                    el.setAttribute("src", s);
                    if (set) el.setAttribute("srcset", s);
                });
            }
        });
    }
};

document.addEventListener("DOMContentLoaded", function() {

    // get youtube links
    const youtubeLinks = document.getElementsByClassName("youtube-embed-link");
    // loop through yt links
    for (let i = 0; i < youtubeLinks.length; i++) {

        const dataSrc = youtubeLinks[i].getAttribute('data-src');

        // if link has a data source then replace with iframe on click
        if(dataSrc !== undefined){
            youtubeLinks[i].onclick = function(e){

                e.preventDefault();

                const dataSrc = this.getAttribute('data-src');

                // load in the youtube iframe
                this.innerHTML = `<iframe src="https://www.youtube.com/embed/${  dataSrc  }" frameborder="0" width="100%" height="315"></iframe>`;

                // remove src so it doesn't keep re-adding for every click
                this.setAttribute('data-src',undefined);
            }
        }
    }
});
